module.exports = __webpack_public_path__ + "static/img/third2_2_3_active.e7109004.jpg";